import type { LocationQuery } from '#vue-router';
import type { SearchIndex } from '@/types/sammy/general';
import type { SearchResponse, SearchResult } from '@/types/sammy/response';

export function useSammySearch(query: ComputedRef<{ q?: string }>, index: SearchIndex = 'combined') {
    const searchResult = ref<SearchResult | null>(null);
    const pending = ref(false);

    if (!query?.value) return { searchResult, pending };

    async function fetchSearchResults(newQuery: LocationQuery) {
        if (!newQuery?.q || Object.keys(newQuery).length === 0 || !index) return;

        pending.value = true;

        try {
            const response = await $fetch<SearchResponse>(`/api/search/${index}`, {
                query: newQuery
            });
            searchResult.value = response.es_result;
        } catch (error) {
            console.error('error while fetching search results', error);
            searchResult.value = null;
        } finally {
            pending.value = false;
        }
    }

    watch(query, fetchSearchResults, { immediate: true });

    return { searchResult, pending };
}
